var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-initials-container"},[_c('div',{class:[_vm.userProsegur ? 'user-prosegur' : 'user-costumer']},[_vm._v(" "+_vm._s(_vm.getCaps())+" ")]),(!_vm.onlyIcon)?_c('div',{staticClass:"user-name"},[_vm._v(" "+_vm._s(_vm.name + " " + _vm.lastName)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }